<template>
  <div class="bg-white rounded shadow  container-box">
    <div class="row">
      <div class="col-md-12 mb-2">

        <!--<mdc-tab-bar class="dashboard-menu report-menu">
          <mdc-tab :active="'client-reports' === route.name"
                   :to="{name: 'client-reports'}" :class="{'can-view': isBCBA || isCurator}">
            {{'user.clients' | trans}}
          </mdc-tab>
          <mdc-tab :active="'curator-reports' === route.name"
                     :to="{name: 'curator-reports'}" :class="{'can-view': isBCBA}">{{'user.curators' | trans}}
          </mdc-tab>
          <mdc-tab :active="'therapist-reports' === route.name"
                   :to="{name: 'therapist-reports'}" :class="{'can-view': isBCBA || isCurator}">
            {{'user.therapists' | trans}}
          </mdc-tab>
          <mdc-tab :active="'archive-reports' === route.name"
                   :to="{name: 'archive-reports'}" :class="{'can-view': isBCBA || isCurator}">
            {{'report.archive_reports' | trans}}
          </mdc-tab>
        </mdc-tab-bar>-->
  
        <nav class="mdc-tab-bar mdc-tab-bar-upgraded dashboard-menu report-menu">
    
          <router-link class="mdc-tab mdc-ripple-upgraded" :to="{name: 'client-reports'}"
                       :class="{'can-view': isBCBA || isCurator, 'mdc-tab--active': 'client-reports' === route.name}">
            <span>{{'user.clients' | trans}}</span></router-link>
    
          <router-link class="mdc-tab mdc-ripple-upgraded"
                       :to="{name: 'curator-reports'}"
                       :class="{'can-view': isBCBA, 'mdc-tab--active': 'curator-reports' === route.name}">
            <span>{{'user.curators' | trans}}</span></router-link>
  
          <router-link class="mdc-tab mdc-ripple-upgraded"
                       :to="{name: 'therapist-reports'}"
                       :class="{'can-view': isBCBA || isCurator, 'mdc-tab--active': 'therapist-reports' === route.name}">
            <span>{{'user.therapists' | trans}}</span></router-link>
  
          <router-link class="mdc-tab mdc-ripple-upgraded"
                       :to="{name: 'archive-reports'}"
                       :class="{'can-view': isBCBA || isCurator, 'mdc-tab--active': 'archive-reports' === route.name}">
            <span>{{'report.archive_reports' | trans}}</span></router-link>
        </nav>
        
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';

  export default {
    name: 'DashboardReport',
    computed: {
      ...mapGetters('auth', [
        'isBCBA',
        'isCurator'
      ]),
      ...mapState([
        'route',
      ]),
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/reports/components/ReportsLayout.vue